import { FieldHookConfig, useField } from 'formik';
import { nanoid } from 'nanoid';
import React from 'react';

export default function CustomTextareaField(
  props: FieldHookConfig<string> & { title: string, placeholder: string }
) {
  const [field] = useField(props);
  const id = nanoid();
  return (
    <div className="w-full text-[#53586C]">
      <label htmlFor={id} className="font-medium">
        {props.title}
      </label>
      <textarea
        id={id}
        className="w-full border border-[#53586C] rounded py-3 px-4 placeholder:text-gray-700/70 mt-3 resize-none"
        placeholder={props.placeholder}
        rows={2}
        {...field}
      />
    </div>
  );
}
